import React, { useEffect } from "react"
import ReactDOM from "react-dom"
import tw, { styled } from "twin.macro"
import { motion, AnimatePresence } from "framer-motion"

import Lightbox from "components/lightbox"
import IconClose from "images/icons/close.inline.svg"

const Content = styled.div`
  ${tw`flex flex-col flex-shrink-0 items-center w-screen h-screen font-body text-white fixed top-0 left-0`}
  overflow: auto;
  padding-bottom: 50px;
  padding-top: 50px;
  z-index: 500;
`
const Modal = ({ children, onClose, isVisible }) => {
  useEffect(() => {
    const originalStyle = window.getComputedStyle(
      document.querySelector("html")
    ).overflow
    if (isVisible) {
      document.querySelector("html").style.overflow = "hidden"
    } else {
      document.querySelector("html").style.overflow = originalStyle
    }

    return () => (document.querySelector("html").style.overflow = originalStyle)
  }, [isVisible])

  if (typeof document !== `undefined`) {
    return ReactDOM.createPortal(
      <AnimatePresence>
        {isVisible && (
          <motion.div
            key="modal"
            initial={{ opacity: 0, zIndex: 500, position: "absolute" }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{ zIndex: 500, position: "absolute" }}
          >
            <Lightbox onClick={onClose} style={{ zIndex: 500 }} opacity={95} />
            <Content onClick={onClose}>
              {children}
              <button
                onClick={onClose}
                className="fixed top-0 right-0 m-6 m:m-8"
              >
                <IconClose />
              </button>
            </Content>
          </motion.div>
        )}
      </AnimatePresence>,
      document.getElementById("modal-container")
    )
  } else {
    return null
  }
}

export default Modal
